import { render } from "./Fpp.vue?vue&type=template&id=6f1dc448&scoped=true"
import script from "./Fpp.vue?vue&type=script&lang=js"
export * from "./Fpp.vue?vue&type=script&lang=js"

import "./Fpp.vue?vue&type=style&index=0&id=6f1dc448&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1dc448"]])

export default __exports__